export default __webpack_public_path__ + "static/media/event5.56b0fe02.png";